import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link, { linkBase } from '@src/mobile/components/Link';
import { isIOS } from '@src/public/utils';
import styles from './index.css';
import { ListStore } from '../../store';
import { openAppShare } from '@src/public/utils/app';

const cx = classNames.bind(styles);

const More = ({ close }) => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { id, title, summary, shareImgUrl } = listStates;

    return (
        <div className={styles.wrap}>
            <div className={styles.content}>
                <div className={styles.btnGroup}>
                    <div
                        className={styles.btn}
                        onClick={() => {
                            const shareTitle = title;
                            const desc = summary;
                            const url = `${window.location.origin.replace('timeline', 'ishare')}${
                                window.location.pathname
                            }${window.location.search}`;

                            close();
                            openAppShare({
                                title: shareTitle,
                                desc,
                                thumbnail: shareImgUrl,
                                url,
                            });
                        }}>
                        <div className={cx('btnIcon', 'iconShare')} />
                        <div className={styles.btnText}>转发</div>
                    </div>

                    {/* {!isIOS() ? ( */}
                    {/*     <div */}
                    {/*         className={styles.btn} */}
                    {/*         onClick={() => { */}
                    {/*             close(); */}
                    {/*             changeListStates({ showShareLongImg: true }); */}
                    {/*         }}> */}
                    {/*         <div className={cx('btnIcon', 'iconShareImg')} /> */}
                    {/*         <div className={styles.btnText}>分享长图</div> */}
                    {/*     </div> */}
                    {/* ) : null} */}
                    <div
                        className={styles.btn}
                        onClick={() => {
                            close();
                            changeListStates({ showShareLongImg: true });
                        }}>
                        <div className={cx('btnIcon', 'iconShareImg')} />
                        <div className={styles.btnText}>分享长图</div>
                    </div>

                    {/* <div */}
                    {/*     className={styles.btn} */}
                    {/*     onClick={() => { */}
                    {/*         close(); */}
                    {/*     }}> */}
                    {/*     <Link to={`${linkBase}/loc/timeline/feedback/${id}`}> */}
                    {/*         <div className={cx('btnIcon', 'iconReply')} /> */}
                    {/*         <div className={styles.btnText}>反馈建议</div> */}
                    {/*     </Link> */}
                    {/* </div> */}
                    <div
                        className={styles.btn}
                        onClick={() => {
                            close();
                        }}>
                        <Link to={`${linkBase}/loc/timeline/report/${id}`}>
                            <div className={cx('btnIcon', 'iconReport')} />
                            <div className={styles.btnText}>举报</div>
                        </Link>
                    </div>
                </div>
            </div>
            <div
                className={styles.cancel}
                onClick={() => {
                    close();
                }}>
                取消
            </div>
        </div>
    );
};

More.propTypes = {
    close: PropTypes.func,
};

export default More;
